import { render, staticRenderFns } from "./alertPerson.vue?vue&type=template&id=69ea49ef&scoped=true"
import script from "./alertPerson.vue?vue&type=script&lang=js"
export * from "./alertPerson.vue?vue&type=script&lang=js"
import style0 from "./alertPerson.vue?vue&type=style&index=0&id=69ea49ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ea49ef",
  null
  
)

export default component.exports